import { Toast, ToastMessage } from "primereact/toast";
import * as React from "react";
import { useContext, useLayoutEffect, useRef, useState } from "react";

const ToastContext = React.createContext<Toast | null>(null);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [toast, setToast] = useState<Toast | null>(null);
  return (
    <>
      <ToastContext.Provider value={toast}>
        {toast ? children : null}
        <Toast ref={setToast} />
      </ToastContext.Provider>
    </>
  );
};

export const useClearToastsOnUnmount = () => {
  const messages = useRef<ToastMessage[]>([]);
  const toast = useToast();

  useLayoutEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps -- pre-existing, not yet audited
      messages.current.forEach((m) => toast.remove(m));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- pre-existing, not yet audited
  }, []);

  return (m: ToastMessage): ToastMessage => {
    messages.current.push(m);

    return m;
  };
};

export const useToast = () => {
  const toast = useContext(ToastContext);

  if (!toast) {
    throw new Error("No Toast provided");
  }

  return toast;
};
